import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { getShiftDetailsV2 } from "../../../store/scheduler-slice";
import { WorkersPropsV2 } from "../shift-details-dialog/types";

// What WorkersV2 returns besides the Worker list that the picker needs
export interface DraftShiftWorkersData {
	workers: WorkersPropsV2[];
	shiftAllocationType?: string;
	isPartialSignupEnabled?: boolean;
	isFlexiSignupEnabled?: boolean;
	isOverlappigSignupEnabled?: boolean;
	overlappingSignupLimitMins?: number;
	isShiftOpenForOtherLocation?: boolean;
	locationCluster?: string | null;
}

// WorkersV2 answers for a draft too, so the picker reads the same list the
// Shift Details Assign step does. The result is kept here rather than read
// from the store so a previous Shift's list can never show for this one.
const useDraftShiftWorkers = (shiftId: number | null) => {
	const dispatch = useDispatch();
	const [data, setData] = useState<DraftShiftWorkersData | null>(null);
	const [isLoading, setIsLoading] = useState(false);

	useEffect(() => {
		if (!shiftId) {
			setData(null);
			return;
		}
		let isCurrent = true;
		setIsLoading(true);
		setData(null);
		// The store's dispatch is not typed for thunks here
		(
			dispatch(getShiftDetailsV2({ shiftid: shiftId })) as unknown as {
				unwrap: () => Promise<{ data: DraftShiftWorkersData }>;
			}
		)
			.unwrap()
			.then((result) => {
				if (isCurrent) setData(result?.data ?? null);
			})
			.catch((err: unknown) => {
				// The picker then shows its empty state
				if (isCurrent) setData(null);
				console.error("Error loading Workers for the Shift", err);
			})
			.finally(() => {
				if (isCurrent) setIsLoading(false);
			});
		return () => {
			isCurrent = false;
		};
	}, [dispatch, shiftId]);

	return { data, isLoading };
};

export default useDraftShiftWorkers;
